import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS
} from '../../../../../../CodeMaster'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {NatSealField, SealField} from './NatSealField'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import moment from 'moment'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'
import {NatHeavyLoadsCarryApplyDetail} from '../../../repository/NatGetHeavyLoadsCarryApply';

interface Props {
    heavyLoadsCarryApplicationDocumentParam: NatHeavyLoadsCarryApplyDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatHeavyLoadsCarryApplicationDocument: React.FC<Props> = props => {
    const {
        heavyLoadsCarryApplicationDocumentParam,
        applyStatusInfoList
    } = props

    const {
        applyId,
        condominiumName,
        ridgeName,
        roomNumber,
        applicantFamilyName,
        applicantFirstName,
        heavyWeightGoodsDetail,
        carryingStartDate,
        carryingEndDate,
    } = heavyLoadsCarryApplicationDocumentParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>重量物搬入等届</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、使用規則に基づき、重量物の搬入・搬出・移動等を実施したいので届出をいたします。<br/>
                なお、使用規則に定められている荷重制限を超える重量物は持ち込みません。<br/>
                また当該作業を原因として近隣住戸からのクレーム等が生じた場合も自主的に解決し、<br/>
                後日異議の申し立てをいたしません。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('2  重量物の内容', heavyWeightGoodsDetail)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>
                        3  重量物の搬入等期間
                    </Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('開始日', renderCarryingDate(carryingStartDate))}
                        {renderApplicationDetail('終了日', renderCarryingDate(carryingEndDate))}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatHeavyLoadsCarryApplicationDocument.displayName = 'NatHeavyLoadsCarryApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderCarryingDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    })

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
